export type ListingInfoAttribute =
  | "SDE"
  | "EBITDA"
  | "REVENUE"
  | "PROFIT"
  | "SBA_PREQUALIFIED"
  | "FINANCING_AVAILABLE"
  | "MINIMUM_DOWN_PAYMENT"
  | "PROPERTY_INCLUDED"
  | "OWNER_WEEKLY_HOURS"
  | "FFANDE"
  | "INVENTORY";

export const LISTING_ATTRIBUTE_BOOST_VALUE = 50;

export const LISTING_ATTRIBUTE_WEIGHT_TABLE: Record<
  ListingInfoAttribute,
  number
> = {
  // Tier 1: Core Financial Performance (What a buyer wants to see first)
  SDE: 95,
  EBITDA: 90,
  REVENUE: 85,
  PROFIT: 75,

  // Tier 2: Deal Feasibility & Financing (Can a buyer make this deal happen?)
  SBA_PREQUALIFIED: 70,
  FINANCING_AVAILABLE: 65,
  MINIMUM_DOWN_PAYMENT: 60,

  // Tier 3: Operational & Asset Details (Important context for the business)
  PROPERTY_INCLUDED: 55,
  OWNER_WEEKLY_HOURS: 50,
  FFANDE: 40,
  INVENTORY: 35,
};
